import {
  CHANGE_ZOOM,
  CHANGE_CENTER,
  CHANGE_PITCH,
  CHANGE_BEARING,
  CHANGE_POPUPHTML,
  CHANGE_MARKER,
  CHANGE_STYLE,
  CHANGE_POSTTYPE,
  CHANGE_MAPTYPE,
  CHANGE_LATLNGREFS,
  CHANGE_MAPDATA,
  CHANGE_MAP_CATEGORIES,
  CHANGE_CONTROL,
  CHANGE_MARKER_COLOR,
  CHANGE_MAP_LAYERS_FILTERS,
  CHANGE_POPUP_STYLE,
  CHANGE_DIRECTIONS_PREFILL
} from '../actions/index';
import $ from 'jquery';

var defaultMapObject = {
  zoom : 1,
  style : 'mapbox://styles/mapbox/streets-v10',
  center : [-40,23], // lng, lat
  pitch : 0,
  controls : {
    navigation : true,
    geocoder : true,
    fullscreen : true,
    scale : false,
    directions : false,
    scrollZoom: true,
    categoryFilter: false,
    layerFilter : false,
    preFillInput: false,
    geolocaterControl: false,
    locationSidebar : false,
    markerNoDisappear : false,
    clusterMarkers : false
  },
  bearing : 0,
  mapType : 'custom',
  postType : false,  // only set if wordpress type
  latRef : false, // only set if wordpress type
  lngRef : false, // only set if wordpress type
  mapData : [], // only set if data type,
  mapSources : [],
  mapLayers : [],
  markerIcon : 'map-icon-map-pin',
  markerColor : '#000000',
  popupHTML : '<h1 style="margin:0;">{title}</h1><p>{content}</p><a target="_blank" href="{link}">See more</a>',
  mapCategories: [],
  popupStyle : {
    popupTip : true,
    roundedCorners : false,
    backgroundColor : '#FFFFFF',
    borderColor : '#FFFFFF'
  },
  mapLayersFilter: [],
  preFillDirections: {
    origin: '',
    destination: ''
  }
};

if($('#wp_mapbox_gl_js_map_object').length) {
  if($('#wp_mapbox_gl_js_map_object').val()!=='') {
    defaultMapObject = JSON.parse($('#wp_mapbox_gl_js_map_object').val());

    // Add needed properties to map object for GL JS
    defaultMapObject.controls.scrollZoom = (typeof defaultMapObject.controls.scrollZoom !== 'undefined') ? defaultMapObject.controls.scrollZoom : true;
    // For maps created before September '18
    if (typeof defaultMapObject.scrollZoom !== 'undefined') {
        defaultMapObject.controls.scrollZoom = defaultMapObject.scrollZoom;
        delete defaultMapObject.scrollZoom;
    }
    defaultMapObject.controls.geolocaterControl = (typeof defaultMapObject.controls.geolocaterControl !== 'undefined') ? defaultMapObject.controls.geolocaterControl : false;
    defaultMapObject.mapCategories = defaultMapObject.mapCategories && defaultMapObject.mapCategories.length > 0 ? defaultMapObject.mapCategories : [],
    defaultMapObject.mapLayersFilter = defaultMapObject.mapLayersFilter && defaultMapObject.mapLayersFilter.length > 0 ? defaultMapObject.mapCategories : [],
    defaultMapObject.preFillDirections = defaultMapObject.preFillDirections ? defaultMapObject.preFillDirections : {};
    defaultMapObject.preFillDirections = defaultMapObject.preFillDirections.origin || defaultMapObject.preFillDirections.destination ? defaultMapObject.preFillDirections : { origin: '', destination: '' };
    defaultMapObject.popupStyle = defaultMapObject.popupStyle ? defaultMapObject.popupStyle : {
      popupTip : true,
      roundedCorners : false,
      backgroundColor : '#FFFFFF',
      borderColor : '#FFFFFF'
    };

    defaultMapObject.mapData.forEach(function(feature) {
      if(feature.properties) {
        feature.properties.category = feature.properties.category ? feature.properties.category : "";
        feature.properties.popup_open = typeof feature.properties.popup_open === 'undefined' ? false : feature.properties.popup_open;
        feature.properties.opacity = feature.properties.opacity ? feature.properties.opacity : 0.4;
        feature.properties.marker_icon_anchor = feature.properties.marker_icon_anchor ? feature.properties.marker_icon_anchor : "bottom";

        if(feature.properties.marker_icon_url.indexOf('/')===-1) {
          feature.properties.marker_icon_url = $('#wp_mapbox_gl_js_plugin_url').val()+"/wp-mapbox-gl-js/admin/wp-mapmaker/public/img/defaults/"+feature.properties.marker_icon_url;
        }
      }
    });
  }
}

const mapObject = (state = defaultMapObject, action) => {
  var stateCopy = JSON.parse(JSON.stringify(state));
  switch (action.type) {
    case CHANGE_MAPDATA:
      stateCopy['mapData'] = action.payload;
      return stateCopy;
    case CHANGE_MAP_LAYERS_FILTERS:
      stateCopy['mapLayersFilter'] = action.payload;
    case CHANGE_DIRECTIONS_PREFILL:
      stateCopy['preFillDirections'] = action.payload;
      return stateCopy;
    case CHANGE_MAP_CATEGORIES:
      stateCopy['mapCategories'] = action.payload;
      return stateCopy;
    case CHANGE_POSTTYPE:
      stateCopy['postType'] = action.payload;
      return stateCopy;
    case CHANGE_POPUP_STYLE:
      stateCopy['popupStyle'] = action.payload;
      return stateCopy;
    case CHANGE_LATLNGREFS:
      stateCopy['latRef'] = action.payload.lat;
      stateCopy['lngRef'] = action.payload.lng;
      return stateCopy;
    case CHANGE_MAPTYPE:
      stateCopy['mapType'] = action.payload;
      return stateCopy;
    case CHANGE_ZOOM:
      stateCopy['zoom'] = action.payload;
      return stateCopy;
    case CHANGE_CENTER:
      stateCopy['center'] = action.payload;
      return stateCopy;
    case CHANGE_BEARING:
      stateCopy['bearing'] = action.payload;
      return stateCopy;
    case CHANGE_PITCH:
      stateCopy['pitch'] = action.payload;
      return stateCopy;
    case CHANGE_STYLE:
      stateCopy['style'] = action.payload;
      return stateCopy;
    case CHANGE_POPUPHTML:
      stateCopy['popupHTML'] = action.payload;
      return stateCopy;
    case CHANGE_MARKER:
      stateCopy['markerIcon'] = action.payload;
      return stateCopy;
    case CHANGE_MARKER_COLOR:
      stateCopy['markerColor'] = action.payload;
      return stateCopy;
    case CHANGE_CONTROL:
      stateCopy['controls'][action.payload.type] = action.payload.onoroff;
      return stateCopy;
    default:
      return state
  }
}

export default mapObject



// WEBPACK FOOTER //
// ./src/reducers/reducer_map_object.js